import { render, staticRenderFns } from "./ImageLightbox.vue?vue&type=template&id=b20bdda0&scoped=true&"
import script from "./ImageLightbox.vue?vue&type=script&lang=js&"
export * from "./ImageLightbox.vue?vue&type=script&lang=js&"
import style0 from "./ImageLightbox.vue?vue&type=style&index=0&id=b20bdda0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20bdda0",
  null
  
)

export default component.exports